/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import isEqual from 'lodash.isequal';
import {createSelectorCreator, defaultMemoize} from 'reselect';

/**
 * Provides a utility which provides a deep equality comparison for use by
 * complex immutable type selectors (not to be used for primitives).
 *
 * ```typescript
 *  import {createDeepEqualSelector} from '@ion/applications/src/store/selectors/SelectorUtils';
 *  ...
 *  const selectTrafficSubLayers = ({tracking: {maps}}: TrackingReducerState) => maps.trafficSubLayers;
 *  ...
 *  export const trafficSubLayersSelector = createDeepEqualSelector(selectTrafficSubLayers,
 *    (selectTrafficSubLayers: string[]): string[] => selectTrafficSubLayers
 *  );
 * ```
 */
export const createDeepEqualSelector = createSelectorCreator(
  defaultMemoize,
  isEqual
);
